<template>
	<div class="payment">
		<div class="payment-switcher txt-center">
			<h2>Seleccione medio de pago</h2>
			<h3>Tarjeta de credito</h3>
			<router-link :to="{ name: 'form', query: $route.query }" class="payment-switcher-btn">
				<img src="@/assets/cards.png" alt="" />
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Switcher',

		data() {
			return {}
		}
	}
</script>
